import { render, staticRenderFns } from "./ViewHitch.vue?vue&type=template&id=1b9fc70d&"
import script from "./ViewHitch.vue?vue&type=script&lang=js&"
export * from "./ViewHitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports